import { render, staticRenderFns } from "./bookDetails.vue?vue&type=template&id=0c31f818&scoped=true"
import script from "./bookDetails.vue?vue&type=script&lang=js"
export * from "./bookDetails.vue?vue&type=script&lang=js"
import style0 from "./bookDetails.vue?vue&type=style&index=0&id=0c31f818&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31f818",
  null
  
)

export default component.exports